import React from "react";
import { Link } from "react-router-dom";

const EventosListar = ({eventos, ano}) => {
    const basePath = "/evento";
    return (
      <div className="container">
        <section className="no-bg">
          <div className="container z-1000">
            <div className="row gx-5 align-items-center">
              <div className="col-lg-12 calendario-head mb-3">
                {ano ? (
                  <p className="mb-0">Calendário {ano}</p>
                ) : (
                  <p className="mb-0">Realizados</p>
                )}
              </div>      
            </div>
          </div>
        </section>

        <div className="row g-4">
          {Array.isArray(eventos) && eventos.length > 0 ? (
            eventos.map((evento) => (
              <div key={evento.id} className="col-lg-3 col-md-6 mb10">
                <div className="bloglist item">
                  <div className="post-content">
                    <div className="image-calendario">
                      <Link to={`${basePath}/${evento.url}`}>
                        <img src={evento.foto} alt={evento.nome} title={evento.sobre} />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <section>
              <div className="container">
                <div className="row align-items-center gh-5">
                    <div className="col-lg-6 position-relative">
                        <div className="images-deco-1">
                            <img src="./img/misc/treino.png" className="d-img-1" alt=""/>
                            <img src="./img/misc/treino2.png" className="d-img-2" alt=""/>
                            <div className="d-img-3 bg-color"></div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <p >“Em breve novos eventos!</p>
                    </div>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    );
}

export default EventosListar;
